module.exports = __webpack_public_path__ + "files/723f1717e327a59abe9438a6b4d3876c.png";